import { useEffect, useState, useCallback } from 'react';
import Link from 'next/link';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';

import { getBackupImg } from '@helpers/dataExists';
import { checkValidDate } from '@helpers/product';
import { useUsedSelector } from '@stores/used/selectors';
import { reqUsedCollectionAction } from '@stores/used/actions';
import { Container, Card } from '@components';
import { categoryFilter } from '@components/OptionalFeature';
import styles from './Categories.module.scss';

const DynamicImage = dynamic(() => import('@components/DynamicImage'), { ssr: false });

const Categories = ({ data, componentIsAvailable, showTitle, componentTitle }) => {
  const router = useRouter();
  const { locale } = router;
  const dispatch = useDispatch();
  const CategorySequence = data?.DisplayOptions?.find((item) => item?.DisplayOptionKey == 'CategorySequence')?.OptionInformation;

  // array for handling categories filter
  const [availableCats, setAvailableCats] = useState([]);

  let categories = useSelector(useUsedSelector);
  const CategorySequenceArray = categoryFilter(CategorySequence, categories);
  categories = Array.isArray(categories) ? (CategorySequenceArray ? CategorySequenceArray : categories) : [];

  useEffect(async () => {
    await getBackupImg();
  });

  useEffect(() => {
    dispatch(reqUsedCollectionAction());
  }, [locale]);

  //This function find categories with at least one product
  //(none of the dates must be negative)
  const showCategoriesFilter = useCallback(() => {
    let finalArray = [];
    categories?.filter((cat) => {
      const returnedval = { ...cat };
      let storageArray = [];
      returnedval.products = [];
      cat.products.map((x) => {
        if (checkValidDate(x.postDate, x.expiryDate, x.solddateon)) {
          returnedval.products = [...returnedval.products, x];
          returnedval.count = returnedval.products.length;
          storageArray = { ...returnedval };
        }
        return storageArray;
      });
      if (storageArray.length != 0) {
        finalArray.push(storageArray);
      }
    });
    setAvailableCats(finalArray);
  }, []);

  useEffect(() => {
    if (categories.length > 0 && availableCats.length <= 0) {
      showCategoriesFilter();
    }
  }, [categories]);

  return (
    componentIsAvailable && (
      <section className={styles.Section}>
        <Container className={styles.Container}>
          {showTitle && <h2 className={styles.Title}>{componentTitle}</h2>}
          {availableCats.length > 0 && (
            <ul className={styles.CategoryList}>
              {availableCats.map((category, index) => {
                return (
                  <Link
                    href={`/products/used/search/${category.id}`}
                    key={`category--id-${index}`}
                    prefetch={false}
                  >
                    <Card tag="a">
                      <Card.Media>
                        <DynamicImage
                          imgSrc={`/api/static/media/byFile/UsedMachinery/background/${category.handle.replaceAll('-', '')}/${
                            category.handle
                          }_N_N_N_I_300X168.jpg`}
                          sizes={'300X168'}
                          alt={category.name}
                        />
                      </Card.Media>
                      <div className={styles.Toptitle}>
                        {locale === 'fr' ? category.name_fr : category.name} <span className={styles.count}>({category.count})</span>
                      </div>
                    </Card>
                  </Link>
                );
              })}
            </ul>
          )}
        </Container>
      </section>
    )
  );
};

export default Categories;
